// The entry stays tiny on purpose: it defers the real startup in
// boot.js to the frame after the first paint. On a phone, the LiveView
// runtime evaluating before Chrome's first frame was the largest single
// cost in the paint time, and nothing on screen depends on it until the
// socket connects, which is a few hundred milliseconds later either
// way. It imports no CSS either: the vendor sheets ride in the Tailwind
// builds, so this file is one request with no chunks behind it.
requestAnimationFrame(() => {
  import("./boot")
})
